<template lang="pug">
#thank_you
  custom-header(
    :title="thanks.area01_Title",
    :subTitle="thanks.area01_SubTitle",
    :image="thanks.area01_Image"
  )
  section.container-fluid.bg_light_blue.i_pt_12.i_pt_md_6.i_pt_sm_8.i_pb_16
    .container
      .row
        .col-12.i_mb_6(
          v-for="(thanks, index) in currentThankList",
          :key="index"
        )
          card(:item="thanks")
      .row
        .col-12.text.center.justify-content-center
          b-pagination(
            v-model="currentPage",
            :total-rows="totalRows",
            :per-page="perPage",
            first-number,
            last-number
          )
  dedicated-line
  custom-footer
</template>

<script>
import CustomHeader from "@/components/customer_service/Header";
import Card from "@/components/thanks/Card";
import DedicatedLine from "@/components/customer_service/DedicatedLine";
import CustomFooter from "@/components/common/Footer";
import { getThanks, getThanksList } from "@/json/customer_service";

export default {
  name: "Thanks",
  metaInfo() {
    return {
      title: this.thanks.SEO_Title,
      meta: [{ name: "description", content: this.thanks.SEO_Description }],
    };
  },
  components: {
    CustomHeader,
    DedicatedLine,
    Card,
    "custom-footer": CustomFooter,
  },
  data() {
    return {
      totalRows: 0,
      perPage: 6,
      currentPage: 1,
      thanks: {},
      tempList: [],
      thanksList: [],
      currentThankList: [],
    };
  },
  created() {
    this.getThanks();
  },
  watch: {
    currentPage() {
      this.getCurrentList();
    },
  },
  methods: {
    getThanks() {
      getThanks().then((response) => {
        this.thanks = response.data;
        this.getThanksList();
      });
    },
    getThanksList() {
      this.thanksList = [];
      getThanksList().then((response) => {
        this.tempList = response.data;
        for (let x in this.tempList.ThanksList) {
          let temp = this.tempList.ThanksList[x];
          if (this.thanks.area02_Thanks_List.includes(temp.ID)) {
            this.thanksList.push(temp);
          }
        }
        this.totalRows = this.thanksList.length;
        this.getCurrentList();
      });
    },
    getCurrentList() {
      this.currentThankList = [];
      let number = this.perPage * this.currentPage;
      this.currentThankList = this.thanksList.slice(
        number - this.perPage,
        number
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/pagination";
</style>
